import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BlinkerComponentModule } from "../blinker/blinker.component.module";
import { LaunchCountdownComponentModule } from "../launch-countdown/launch-countdown.component.module";
import { LaunchTimeComponent } from "./launch-time.component";

@NgModule({
  imports: [
    // Common
    CommonModule,
    BlinkerComponentModule,
    LaunchCountdownComponentModule
  ],
  declarations: [LaunchTimeComponent],
  exports: [LaunchTimeComponent],
})
export class LaunchTimeComponentModule { }
